import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedDate, FormattedNumber, FormattedTime} from "react-intl";
import moment from "moment";
import Duration from "components/Duration";
import {formatPhone} from "helpers/phone";

class HistoryItem extends React.Component {
    static propTypes = {
        item: PropTypes.shape({
            date: PropTypes.object.isRequired,
            revenue: PropTypes.number,
            type: PropTypes.string.isRequired,
            phone: PropTypes.string.isRequired,
            timeStarted: PropTypes.object,
            timeFinished: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        }).isRequired,
    };

    static getDuration(item) {
        return item.timeStarted && (item.timeFinished
            ? item.timeFinished.diff(item.timeStarted, 'seconds')
            : moment().diff(item.timeStarted, 'seconds'));
    }

    render() {
        const {item} = this.props;

        const length = item.type === "voice"
            ? HistoryItem.getDuration(item)
            : '';

        let label = "";

        if (item.type === "voice") {
            label = <FormattedMessage id="stats.voice_call" defaultMessage="Voice call" />;
        } else if (item.type === "text") {
            if (item.direction_received) {
                label = <FormattedMessage id="stats.inbound_sms" defaultMessage="Inbound SMS" />;
            } else {
                label = <FormattedMessage id="stats.outbound_sms" defaultMessage="Outbound SMS" />;
            }
        }

        return (
            <tbody>
            <tr>
                <td colSpan="2" className="stats__date">
                    <FormattedDate value={item.date}/> <FormattedTime value={item.date}/>
                </td>
            </tr>
            <tr>
                <td className={"stats__price stats__price--" + item.type}>
                    {item.revenue !== null &&
                    <FormattedNumber value={item.revenue} style="currency" currency="CZK"/>
                    }
                    {item.revenue === null &&
                    "—"
                    }
                </td>
                <td>
                    {label} {formatPhone(item.phone)} {length && <Duration showBrackets duration={length}/>}
                </td>
            </tr>
            </tbody>
        )
    }
}

export default HistoryItem;


// WEBPACK FOOTER //
// ./src/containers/Stats/HistoryItem.jsx